package de.oevbs.kunde.kundenportal2.model.services.account

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class AccountClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Löscht den Account des eingeloggten Users, sofern das Passwort in [currentPassword] korrekt ist.
     * Sollte der User Verträge haben, werden diese vorher vom Account getrennt und ein Kontakt zur Account-Löschung
     * angelegt.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun deleteAccount(currentPassword: String): ClientResponse<Unit> =
        post("/account/delete", DeleteAccount(currentPassword))

    /**
     * Ändert das Passwort für den Account des eingeloggten Users, sofern das aktuelle Passwort in
     * [changePassword] korrekt ist und die beiden neuen Passwörter darin übereinstimmen.
     *
     * Diese Funktion kann nicht zum Passwort-Reset bei vergessenen Zugangsdaten verwendet werden, da der User
     * eingeloggt sein muss. Dazu gibt es den ResetClient.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun changePassword(changePassword: ChangePassword): ClientResponse<Unit> =
        post("/account/password", changePassword)

}